import { Injectable } from '@angular/core';
import { HttpHeaders, HttpParams } from "@angular/common/http";
import {environment} from "@env/environment";

@Injectable({
  providedIn: 'root'
})
export class HttpUtilService {

  private readonly API_KEY_HEADER = 'x-apikey';
  public  buildHttpParams(paramsObj:{[key:string]:any}):HttpParams{
    let params = new HttpParams();
    for (const key in paramsObj) {
      if (paramsObj[key] !== null && paramsObj[key] !== undefined && paramsObj[key] !== '') {
        params = params.set(key, paramsObj[key].toString());
      }
    }
    return params;
  }

  public buildHeaders(): HttpHeaders {
    return new HttpHeaders({
      [this.API_KEY_HEADER]: environment.api.apikey
    });
  }

  public getSortElement(sortElement: string, sortMap: { [key: string]: string }): string {
    const normalizedSortElement = sortElement ? sortElement.toUpperCase() : '';
    return sortMap[normalizedSortElement] || normalizedSortElement;
  }


  public removeEmptyProperties(obj: any): any {
    Object.keys(obj).forEach(key => {
      if (obj[key] === null || obj[key] === undefined || obj[key] === '') {
        delete obj[key];
      }
    });

    return obj;
  }
}
